import omit from 'lodash/omit';
import { actionTypes } from './actionTypes';
import {
  ReducerAddToastActionType,
  ReducerRemoveByKeyActionType,
  ReducerRemoveAllActionType,
  State,
} from './types';

export const initialState: State['toasts'] = {};

const toastContainerReducer = (
  state = initialState,
  action: ReducerAddToastActionType | ReducerRemoveByKeyActionType | ReducerRemoveAllActionType,
) => {
  switch (action?.type) {
    case actionTypes.ADD:
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    case actionTypes.REMOVE_KEY:
      return omit(state, action.payload.key);
    case actionTypes.REMOVE_ALL:
      return {};
    default:
      return state;
  }
};

export default toastContainerReducer;
